<template>
  <div class="city-combobox-wrapper">
    <v-autocomplete
      id="municipio-select"
      v-model="filter.municipio"
      item-text="nome"
      item-name="municipioId"
      :items="municipios"
      :label="noLabel ? '' : label || 'Município'"
      placeholder="Selecione um Município"
      @change="$emit('changeCity', filter.municipio)"
      :multiple="isMultiple ? true : false"
      :return-object="true"
      clearable
      :menu-props="{ maxHeight: '320px' }"
      :search-input.sync="termoBusca"
      persistent-placeholder
      hide-details
      dense
      solo
      flat
      :outlined="outlined"
      :filled="filled"
      :loading="loading"
      class="city-autocomplete"
    >
      <template slot="no-data">
        <div class="d-flex align-center justify-center pa-3">
          <v-progress-circular
            v-if="loading"
            indeterminate
            size="24"
            width="2"
            color="primary"
            class="mr-2"
          ></v-progress-circular>
          <span v-if="loading">Carregando municípios...</span>
          <span v-else>Nenhum Município retornado</span>
        </div>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { cityAPI } from "@/modules/city";

export default {
  name: "AppCityComboboxSingle",
  props: ["filter", "isMultiple", "label", "noLabel", "outlined", "filled"],
  data() {
    return {
      municipios: [],
      termoBusca: "",
      loading: false,
    };
  },
  mounted() {
    this.loadCities();
  },
  methods: {
    loadCities() {
      this.loading = true;
      cityAPI
        .listNames()
        .then((resp) => {
          this.municipios = resp.data;
        })
        .catch()
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.city-combobox-wrapper {
  position: relative;
}

/* Estilo do campo principal */
.city-autocomplete {
  border: 1px solid #e0e0e0 !important;
  border-radius: 4px !important;
  background: white !important;
}

.city-autocomplete >>> .v-input__control {
  min-height: 40px !important;
}

.city-autocomplete >>> .v-input__slot {
  margin-bottom: 0 !important;
  padding: 0 12px !important;
  border: none !important;
  border-bottom: none !important;
  box-shadow: none !important;
  background: none !important;
}

/* Remove COMPLETAMENTE todas as linhas do Vuetify */
.city-autocomplete >>> .v-input__slot:before,
.city-autocomplete >>> .v-input__slot:after,
.city-autocomplete >>> .v-input__control:before,
.city-autocomplete >>> .v-input__control:after,
.city-autocomplete >>> .v-text-field__details:before,
.city-autocomplete >>> .v-text-field__details:after,
.city-autocomplete >>> .v-input--is-focused .v-input__slot:before,
.city-autocomplete >>> .v-input--is-focused .v-input__slot:after {
  display: none !important;
  border: none !important;
  border-bottom: none !important;
  content: none !important;
  height: 0 !important;
  width: 0 !important;
}

/* Alinhamento dos ícones */
.city-autocomplete >>> .v-input__icon {
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-top: 0 !important;
}

.city-autocomplete >>> .v-input__icon--append .v-icon {
  margin-top: 0 !important;
}

/* Melhora o alinhamento do texto */
.city-autocomplete >>> .v-select__selections {
  align-items: center;
  padding: 8px 0;
}

.city-autocomplete >>> .v-label {
  top: 50% !important;
  transform: translateY(-50%) !important;
  margin-top: 0 !important;
}

/* Quando o label está ativo (floating) */
.city-autocomplete >>> .v-label--active {
  top: -6px !important;
  transform: translateY(0) scale(0.75) !important;
}

/* Remove o foco outline padrão e adiciona um personalizado */
.city-autocomplete >>> .v-input__control:focus-within {
  border-color: #1976d2;
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}

/* Placeholder styling */
.city-autocomplete >>> .v-select__slot input::placeholder {
  color: #9e9e9e;
  opacity: 1;
}
</style>
